import { useLanguage } from '../../context/LanguageContext';

function TextAreaInputTile({
  maxLength = 30,
  required = false,
  name = 'playerAnswer',
  onChange = () => {},
  value = '',
}) {
  const { t } = useLanguage();

  return (
    <textarea
      id={name}
      name={name}
      className={
        'focus:outline-none dark:bg-background-dark p-4 py-3 mt-4 border border-gray rounded-2xl w-full'
      }
      value={value}
      onChange={onChange}
      placeholder={t('yourAnswerHere')}
      maxLength={maxLength}
      required={required}
      rows={3}
      cols={50}
    />
  );
}

export default TextAreaInputTile;
